import { connect } from 'react-redux';
import React, { Component } from 'react';
import { renderKBInput, renderKBMorePhotoUpload, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';

import { bindActionCreators } from 'redux';
import * as valid from 'utils/validate';
import { api } from 'app/services';
import { subscriptionActions } from 'app/actions';
import PropTypes from 'prop-types';
import {
KBFormError,
KBButton,
KBPopover } from
'components';
import config from 'app/config';
import { showApiError } from 'utils/feedback';

var RealSubscriptionForm = class extends React.Component {constructor(props) {super(props);this.updateSubScriptionForm = this.updateSubScriptionForm.bind(this);}updateSubScriptionForm(
  model) {
    const { updateSubScriptionAction, member, subId } = this.props;

    return api.updateSignSubscription(subId, model).then(json => {
      updateSubScriptionAction.success(json);
      KBPopover.close();
    }).catch(error => {
      showApiError(error);
    });
  }render()

  {
    const {
      fields: { serial, file },
      error,
      submitting,
      handleSubmit,
      member,
      org,
      subscriptions } =
    this.props;

    return (
      <form onSubmit={handleSubmit(this.updateSubScriptionForm)}>
        <KBFormError error={error} />
        <header className="kb-form-header">
          <h2 className="header-title">签为正式合同</h2>
          <i
          className="header-close iconfont icon-cancel"
          onClick={KBPopover.close} />

        </header>
        <div className="kb-form-container">
          <div className="kb-row">
            <Field name="serial" component={renderKBInput}
            title="合同编号"
            isRequired={true}
            label="true"
            placeholder="输入合同自有编号"
            className="kb-form-group kb-form-c18 kb-form-alone"

            value={serial.value} />

          </div>
          <div className="kb-row">
            <Field name="file" component={renderKBMorePhotoUpload}
            className="kb-form-group kb-form-c18  kb-form-alone"
            text={file.value ? '合同文件已上传' : '上传合同原文件'}
            uploadingText="正在上传"
            title="上传合同"
            photoShow={false}
            isRequired={true}
            prefix={config.uploadDir + 'subscriptions/'}
            buttonClass={'bordered-btn m-none'}
            uploadedText="上传合同"

            accept="image/*, .doc,.docx,.pdf" />

          </div>
          <div className="f-right">
            <span className="cancel-btn" onClick={KBPopover.close}>
              取消
            </span>
            <KBButton
            className="certain-btn m-left-sm"
            type="submit"
            submitting={submitting}>

              确认
            </KBButton>
          </div>
        </div>
      </form>);

  }};


RealSubscriptionForm.propTypes = {
  subId: PropTypes.string.isRequired };


function mapStateToProps(state, props) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    updateSubScriptionAction: bindActionCreators(
    subscriptionActions.update,
    dispatch) };


}

const validate = values => {
  const errors = {};

  if (valid.required(values.serial)) {
    errors.serial = '请输入合同编号';
  }

  if (valid.required(values.file)) {
    errors.file = '请选择合同原件';
  }

  return errors;
};

const LEGACY_FORM_FIELDS = [
  "serial",
  "file"
];

const formConfig = {
  form: 'OrgSubTerminateForm',
  validate: validate,
  touchOnBlur: false };


RealSubscriptionForm = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('OrgSubTerminateForm', LEGACY_FORM_FIELDS)(RealSubscriptionForm)));

export default RealSubscriptionForm;
